import { NgModule } from '@angular/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Routes, RouterModule } from '@angular/router';
import { ServerErrorPageComponent } from 'core/containers/server-error-page/server-error-page.component';
import { LibraryListViewComponent } from './components/library-list-view/library-list-view.component';
import { LibraryListViewContainerComponent } from './components/library-list-view-container/library-list-view-container.component';
import { LibraryListResolver } from './resolvers/library-list.resolver';
import { NotFoundPageComponent } from 'core/containers/not-found-page/not-found-page.component';

const routes: Routes = [
  {
    path: '',
    component: LibraryListViewContainerComponent,
    children: [
      {
        path: 'list/:listId',
        component: LibraryListViewComponent,
        resolve: {
          loadLibraryList: LibraryListResolver
        }
      },
      {
        path: 'showcase/:showcaseId',
        component: LibraryListViewComponent,
        resolve: {
          loadLibraryList: LibraryListResolver
        },
      },
    ],
  },
  {
    path: 'server-error',
    component: ServerErrorPageComponent,
  },
  {
    path: 'not-found',
    component: NotFoundPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), InfiniteScrollModule],
  exports: [RouterModule],
})
export class LibraryListRoutingModule {
}
